import { Injectable } from "@angular/core";

@Injectable()
export class DateTimeService {
    constructor() {}

    public convertDate(date: any): string {
        let value = new Date(date);
        let month = this.getDigitWithZeroBefore(value.getMonth() + 1);
        let day = this.getDigitWithZeroBefore(value.getDate());

        return value.getFullYear() + "-" + month + "-" + day;
    }

    public convertToUsDateTimeFormat(date: any): string {
        let value = new Date(date);
        let month = this.getDigitWithZeroBefore(value.getMonth() + 1);
        let day = this.getDigitWithZeroBefore(value.getDate());

        return `${month}/${day}/${value.getFullYear()}`;
    }

    public getDateWithTimezoneCorrections(date: any): Date {
        let correctedDate = null;

        if (date) {
            correctedDate = new Date();
            date = new Date(date);
            correctedDate.setUTCHours(date.getHours());
            correctedDate.setUTCMinutes(date.getMinutes());
            correctedDate.setUTCSeconds(date.getSeconds());
        }

        return correctedDate;
    }

    public getTimeFormatAsString(date: Date): string {
        let result = null;

        if (date) {
            let hours = date.getHours();
            let minutes = date.getMinutes();

            result =
                this.getDigitWithZeroBefore(hours) +
                ":" +
                this.getDigitWithZeroBefore(minutes);
        }

        return result;
    }

    private getDigitWithZeroBefore(digit: number) {
        return (digit < 10 ? "0" : "") + digit;
    }

    public correctTimeToUtcFromStringTime(timeString: string) {
        let currentDate = this.getDateFromTimeString(timeString);
        let dateWithTimeCorrections = new Date(
            currentDate.getTime() + currentDate.getTimezoneOffset() * 60000
        );

        return this.getTimeFormatAsString(dateWithTimeCorrections);
    }

    public getDateFromTimeString(timeString) {
        let date = new Date();
        let hours = parseInt(timeString.substring(0, 2));
        let minutes = parseInt(timeString.substring(5, 3));

        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDay(),
            hours,
            minutes,
            0
        );
    }

    public getDateTimeFromTimeString(timeString) {
        let currentDate = new Date();
        let splittedTime = (timeString as any).split(":");

        currentDate.setHours(splittedTime[0]);
        currentDate.setMinutes(splittedTime[1]);
        currentDate.setSeconds(0);
        return currentDate;
    }
}
